<template>
    <div class="innerBox">
  
      <h1 class="mb-3">Price Evaluation</h1>
  
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox" style="padding:0 25%">
          <div class="col row">
            <div class="col-md-6" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Work Order Code</label>
              <input type="text" class="form-control" placeholder="Ketik work order code" style="height: 43px;" v-model="filter.work_order_code">
            </div>
            <div class="col-md-6" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
            </div>
          </div>
        </div>
      </panel>
  
      <vue-universal-table
        api_url="/api/v1/estimations/price-evaluation"
        :fields="vue_universal_table.fields"
        :special_buttons="vue_universal_table.special_buttons"
        :disable_sort="true"
        :update="vue_universal_table.update"
        :filter="filter"
        :process_data="vue_universal_table.process_data"
        :export_config="vue_universal_table.export_config"
      ></vue-universal-table>
  
    </div>
  </template>
  
  <script>  
    export default {
      data () {
        return {
          mobile : this.isMobile(),
          modal : {
            view : false,
          },
          rangeConfig: {
            mode: 'range',
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          detailId : '',
          selected : {
            date : '',
          },
          filter : {
            work_order_code : '',
          },
          vue_universal_table : {
            fields : [
                {
                    title : 'Work Order ID',
                    variable : 'work_order_code'
                },
                {
                    title : 'Sparepart',
                    variable : 'name'
                },
                
                {
                    title : 'Harga Per Barang',
                    variable : 'price_per_item',
                    number_formatting : true
                },
                {
                    title : 'Durasi Inden Barang Terpilih',
                    variable : 'inden_selected',
                },
                {
                    title : 'Harga Terrendah',
                    variable : 'min_price',
                    number_formatting : true
                },
                {
                    title : 'Durasi Inden Barang',
                    variable : 'inden_min_price'
                },
                {
                    title : 'Deskripsi',
                    variable : 'description'
                }
            ],
            special_buttons : ['exportToExcel'],
            update : 0,
            export_config : {
              name : 'Price Evaluation',
              type : 'xlsx',
              all : true
            },
            process_data : `
              for (var i in data) {
                data[i].description = data[i].description ? data[i].description : '-'
                data[i].inden_selected = data[i].inden_selected +  ' Hari'
                data[i].inden_min_price = data[i].inden_min_price +  ' Hari'
              }
            `,
          },
        }
      },
      mounted () {

      },
      methods : {
          
      }
    }
  </script>
  
  <style scoped>
  
  </style>